const isSummarizeOn = (val) => {
    if (typeof (val) == 'string') {
        if (val.includes("K") || val.includes("L") || val.includes("Cr")) {
            return true;
        }
        else
            return false;
    }
    else
        return false;
};
export default isSummarizeOn;
